// src/store/thunks/user/markNotificationReadThunk.ts

import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { NotificationStatus, NotificationStatusDTO } from '@/types/NotificationDTOs';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { fetchNotificationsThunk } from '@/store/thunks/user/fetchNotificationsThunk';

export const markNotificationReadThunk = createAppAsyncThunk<
  NotificationStatusDTO,
  { notificationId: string; status: NotificationStatus }
>(
  'user/markNotificationRead',
  withLoader(
    async({ notificationId, status }, { extra: { userService }, dispatch }) => {
      const response = await userService.markNotificationRead(notificationId, status);
      await dispatch(fetchNotificationsThunk()).unwrap();
      return response;
    }
  )
);
